import React from "react";
import styles from "./style.module.css";

const Header = (props) => {
  return <h2 className={styles.title}>{props.text}</h2>;
};

export default Header;
